namespace TabAurous.ECommerce {
    export interface ECommRepairLaborRow {
        TransLbrId?: number;
        TransItemId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        ProcessId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        CalcOnId?: number;
        LabourRate?: number;
        MarkUp?: number;
        LabourAmount?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        ProcessName?: string;
        Attribute?: string;
        CCLabourAmount?: number;
        IsCustomerItem?: boolean;
        DiscountPercent?: number;
        Discount?: number;
        CalculateTo?: number;
    }

    export namespace ECommRepairLaborRow {
        export const idProperty = 'TransLbrId';
        export const nameProperty = 'ProcessName';
        export const localTextPrefix = 'ECommerce.ECommRepairLabor';
        export const deletePermission = 'EComm:ECommRepair:Delete';
        export const insertPermission = 'EComm:ECommRepair:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommRepair:Edit';

        export declare const enum Fields {
            TransLbrId = "TransLbrId",
            TransItemId = "TransItemId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            ProcessId = "ProcessId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            CalcOnId = "CalcOnId",
            LabourRate = "LabourRate",
            MarkUp = "MarkUp",
            LabourAmount = "LabourAmount",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            ProcessName = "ProcessName",
            Attribute = "Attribute",
            CCLabourAmount = "CCLabourAmount",
            IsCustomerItem = "IsCustomerItem",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            CalculateTo = "CalculateTo"
        }
    }
}
